import React from 'react';
import {useTranslation} from 'react-i18next';
import {IElementQuestionnaire} from '../../../../../incase-domain/elements/base/questionElementBase';
import {QuestionElementInteractions} from '../../../../../incase-domain/proptypes/runfile';
import {useQuestionCounterProps} from '../../../../../hooks/useQuestionCounterProps';

interface IQuestionCounterProps {
    element: IElementQuestionnaire;
    elementInteractions: QuestionElementInteractions;
}

function QuestionCounter({element, elementInteractions}: IQuestionCounterProps): JSX.Element {
    const {t} = useTranslation();
    const {numerator, denominator, hidden, getLabel, showCorrectAnswersCount, correctAnswersCount} = useQuestionCounterProps(
        element,
        elementInteractions
    );

    if (showCorrectAnswersCount) {
        return (
            <div className="c-questionsAnsweredCount c-questionsAnsweredCount--twoLabels">
                <span className="c-questionsAnsweredCount__label">
                    {correctAnswersCount} {t('slide.questionCounter.correctAnswers', {count: correctAnswersCount})}
                </span>
                {!hidden && (
                    <span className="c-questionsAnsweredCount__label">
                        {numerator}/{denominator} {t('slide.questionCounter.answered')}
                    </span>
                )}
            </div>
        );
    }

    if (hidden) {
        return (
            <div className="c-questionsAnsweredCount">
                <div className="c-questionsAnsweredCount__count--singleAttempt" />
            </div>
        );
    }

    return (
        <div className="c-questionsAnsweredCount">
            <div className="c-questionsAnsweredCount__count">{getLabel()}</div>
            <div className="c-questionsAnsweredCount__progressBar">
                <div className="c-questionsAnsweredCount__progressBar_fill" style={{width: `${(numerator / denominator) * 100}%`}} />
            </div>
        </div>
    );
}

export default QuestionCounter;
